import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { 
  DunsUniqueDirective,
  EmailUniqueDirective,
  IntraTvaValidatorDirective,
  IntraTvaWarningDirective,
  intraTvaUniqueDirective,
  OnBlurValidatorDirective,
  RsaUniqueDirective,
  SiretActifDirective,
  SiretUniqueDirective,
  SiretValidatorDirective,
  NoBlankStringDirective,
  SiretHqDirective,
  MinDateDirective,
  MaxDateDirective,
  SiretSiegeDirective,
} from '../all-validators'



@NgModule({
  imports:[    
  CommonModule
  ]
  ,declarations:[
    DunsUniqueDirective,
    EmailUniqueDirective,
    IntraTvaValidatorDirective,
    IntraTvaWarningDirective,
    intraTvaUniqueDirective,
    OnBlurValidatorDirective,
    RsaUniqueDirective,
    SiretActifDirective,
    SiretUniqueDirective,
    SiretValidatorDirective,
    SiretSiegeDirective,
    NoBlankStringDirective,
    SiretHqDirective,
    MinDateDirective,
    MaxDateDirective
  ]
  ,exports:[
    DunsUniqueDirective,
    EmailUniqueDirective,
    IntraTvaValidatorDirective,
    IntraTvaWarningDirective,
    intraTvaUniqueDirective,
    OnBlurValidatorDirective,
    RsaUniqueDirective,
    SiretActifDirective,
    SiretUniqueDirective,
    SiretValidatorDirective,
    SiretSiegeDirective,
    NoBlankStringDirective,
    SiretHqDirective,
    MinDateDirective,
    MaxDateDirective
  ]
})
export class PafAllValidatorsModule{}
